import { PrivateParkingModeType } from "../off-street-parking.type";
import { EditModeIcon, ViewIcon, AddIcon } from "components/icons";
import { ToolboxItem } from "@/components/map-tool-box";

export const offStreetToolboxIcons: ToolboxItem<PrivateParkingModeType>[] = [
  {
    name: "Mode",
    groups: [
      {
        text: "View",
        mode: PrivateParkingModeType.View,
        icon: <ViewIcon className="h-5 w-5" />,
      },

      {
        text: "Add Private parking",
        mode: PrivateParkingModeType.AddPrivateParking,
        icon: <AddIcon className="h-5 w-5" />,
      },
      {
        text: "Edit Private parking",
        mode: PrivateParkingModeType.EditPrivateParking,
        icon: <EditModeIcon className="h-5 w-5" />,
      },
    ],
  },
];
